"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var extractErrorDetailsForAction = exports.extractErrorDetailsForAction = function extractErrorDetailsForAction(error) {
    return error.response ? _extends({ id: error.id, url: error.url }, error.response) : { id: error.id, url: error.url, message: error.message, code: error.code };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/errorUtil.js
// module id = 466
// module chunks = 0